import React, { Fragment } from 'react';
import GoogleAnalytics from '../services/GoogleAnalytics';

import '../assets/css/ButtonLink.scss';

const ButtonLink = ({ favicon, text, link, active, gaEvent }) => {
  return (
    <Fragment>
      <a
        href={link}
        className = {"btn btn-outline-salmon btn-block "+active}
        target="_blank"
        rel="noopener noreferrer"
        alt={text}
        title={link}
        onClick={() =>
          GoogleAnalytics.addEvent(
            gaEvent.category,
            gaEvent.action,
            gaEvent.label,
            gaEvent.value
          )
        }
      >
        {text}
      </a>
    </Fragment>
  );
};

export default ButtonLink;
